import React, { Component } from 'react';
import $ from 'jquery';
import { Label, FormGroup, Form, Button, ButtonGroup, Input, Col, Row, Modal, ModalHeader, ModalFooter, ModalBody, InputGroup, Tooltip, Collapse, UncontrolledTooltip } from 'reactstrap';
import Rows from '../components/Row'
import Header from '../components/Header'
import InfoTable from '../components/tables/InfoTable'
import { connect } from 'react-redux'
import AuthHOC from './Auth'
import { withAlert } from 'react-alert'
import moment from 'moment'
import { Flag } from 'flagger/react';
import SearchIcon from '@mui/icons-material/Search';
import ExportDataRowsModal from '../components/modals/ExportDataRowsModal';
import { Stack, Typography, Box, Button as MuiButton } from '@mui/material';
//import { emitKeypressEvents } from 'readline';

class ConsoleView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            logs: [],
            checkedLogs: [],
            allselected: false,
            modal: false,
            messages: [],
            type: '',
            filters: false,
            isLoading: false,
            associated_events: [],
            collapse: false,
            page_number: 0,
            page_number_load: 98,
            exportFilesModalVisible: false,
            ...props
        }
    }

    componentDidMount() {
        this.setLoading(true);
        //console.log(window.location.protocol + '//' + window.location.host)
        this.getActionEntries()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.filters !== this.state.filters) {
            this.getActionEntries()
        }

        if (prevState.page_number !== this.state.page_number) {
            if (this.state.page_number > this.state.page_number_load) {
                this.getActionEntries();

                this.setState({
                    page_number_load: this.state.page_number + 90
                })
            }
        }
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        })
    }

    setLoading = (loading) => {
        this.setState({
            isLoading: loading
        })
    }

    exportButtonPressed = () => {
        this.setState({
            exportFilesModalVisible: !this.state.exportFilesModalVisible
        })
    }

    getActionEntries = () => {
        this.setLoading(true);
        fetch(window.location.protocol + '//' + window.location.host + '/api/actions/get_all?status=' + this.state.status + '&type=' + this.state.actionType + '&import=' + this.state.importype + '&fromdate=' + this.state.fromDate + '&todate=' + this.state.toDate + '&reference=' + this.state.reference + '&page=' + this.state.page_number, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        })
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result)
                    this.setState({
                        logs: result
                    })
                    this.setLoading(false);
                })
            .catch(error => {
                this.setLoading(false);
            });
    }

    retry = () => {
        this.props.alert.show('Resubmitting document ... ');
        fetch(window.location.protocol + '//' + window.location.host + '/api/processing/re_process_document', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.state.checkedLogs)
        })
            .then(res => res.json())
            .then((result) => {
                this.refresh();
                this.props.alert.success(result.message);
            })
    }

    remove = () => {
        this.setState({
            isLoading: true
        })

        let remove_ids = [];

        for (let action of this.state.checkedLogs) {
            remove_ids.push(action._id)
        }

        fetch(window.location.protocol + '//' + window.location.host + '/api/actions/remove', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(remove_ids)
        })
            .then(res => res.json())
            .then((result) => {
                this.refresh();
            })
    }

    refresh = () => {
        this.setState({
            checkedLogs: [],
            logs: []
        });

        this.getActionEntries()
    }

    selectAll = () => {
        if (this.state.allselected)
            this.setState({
                checkedLogs: [],
                allselected: false
            })
        else
            this.setState({
                checkedLogs: this.state.logs,
                allselected: true
            })
    }

    checkChange = (id) => {
        var found = this.state.logs.find(element => {
            return element._id == id;
        });

        if (!found)
            found = this.state.associated_events[0].associated.find(element => {
                return element._id == id;
            });

        if (!this.state.checkedLogs.includes(found)) {
            this.setState(prevState => ({
                checkedLogs: prevState.checkedLogs.concat(found)
            }))
        }
        else {
            this.setState(prevState => ({
                checkedLogs: prevState.checkedLogs.filter(j => found !== j)
            }))
        }
    }

    rowClicked = (id) => {
        var found = this.state.logs.find(function (element) {
            return element._id == id;
        });

        if (!found) {
            // fix for bug-15536 - not finding element if multiple items are open 
            for (let elements of this.state.associated_events) {
                found = elements.associated.find(element => {
                    return element._id == id;
                });

                if (found)
                    break;
            }
        }

        fetch(window.location.protocol + '//' + window.location.host + '/api/actions/get_messages_for_action?id=' + id)
            .then(res => res.json())
            .then((action) => {
                if (found)
                    action.unshift(found)

                this.setState({
                    type: 'Messages for: ' + action.reference,
                    messages: action,
                    modal: true
                })
            });
    }

    toggleToolTip = (message, id) => {
        if (message.length > 50)
            this.setState({
                [id]: !this.state[id]
            })
    }

    // preform an elastic search from main search box 
    genericSearch = () => {
        this.setState({
            checkedLogs: [],
            logs: [],
            isLoading: true
        });

        fetch(window.location.protocol + '//' + window.location.host + "/api/actions/elastic_search", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ query: this.state.search_text }),
        })
            .then(res => res.json())
            .then((result) => {
                this.setState({
                    logs: result,
                    isLoading: false
                })
            })
    }

    expandLogs = (file) => {
        let id = file.parentId ? file.parentId : file._id;
        let assoc_events = [...this.state.associated_events];

        var found = assoc_events.find(element => {
            return element.id == id;
        });

        if (found) {
            var index = this.state.associated_events.indexOf(found);
            if (index > -1) {
                assoc_events.splice(index, 1);
            }
            this.setState({
                associated_events: assoc_events
            })
        }
        else {
            fetch(window.location.protocol + '//' + window.location.host + '/api/actions/get_actions_for_process?id=' + id)
                .then(res => res.json())
                .then(result => {
                    if (!result.empty) {
                        this.setState(prevState => ({
                            associated_events: prevState.associated_events.concat({
                                id: file.processId ? file.processId : file._id,
                                associated: result
                            })
                        }));
                    }
                })
        }
    }

    // Send the distribution report for a processed document and tell the user what
    // happened. The server answers 200 { result: 'complete' } on success and
    // 500 { error: true, message } on failure (e.g. reports disabled on the template,
    // no recipients), so surface that message instead of swallowing it. Same
    // react-alert pattern as retry() above.
    sendReport = (id) => {
        this.props.alert.show('Sending report ... ');
        fetch(window.location.protocol + '//' + window.location.host + '/api/email/send_process_report?id=' + id)
            .then(res => res.json()
                .then(result => ({ ok: res.ok, result }))
                .catch(() => ({ ok: res.ok, result: {} })))   // non-JSON body (proxy / gateway error page)
            .then(({ ok, result }) => {
                if (!ok || result.error) {
                    this.props.alert.error('Report not sent: ' + (result.message || 'Unknown error'));
                } else {
                    this.props.alert.success('Report sent');
                }
            })
            .catch(error => {
                this.props.alert.error('Report not sent: ' + (error.message || 'Network error'));
            });
    }

    submitFilter = (e) => {
        e.preventDefault();
        this.getActionEntries();
    }

    clearFilter = () => {
        this.setState({
            reference: '',
            status: '',
            actionType: '',
            toDate: '',
            fromDate: '',
            filters: !this.state.filters
        })
    }

    render() {
    const { parsed, localisation } = this.props;

    let messages = [];
    let modal_title = '';
    let hide_button = null;
    let tooltip_text = '';
    let processid = '';
    let parentModal = false;

    if (this.state.messages.length > 0)
        this.state.messages.forEach((message, i) => {
            console.error(message);

            if (!parentModal && message.type === "PROCESSING")
                parentModal = true;

            processid = message.parentId;
            modal_title = 'Messages for: ' + message.reference;

            let container_status;
            if (i === 0)
                container_status = <div className="s-fonticon-btn s-icon-status s-icon-status-info"></div>;
            else if (message.status === 'COMPLETE')
                container_status = <div className="s-fonticon-btn s-icon-status s-icon-status-success"></div>;
            else if (message.status === 'ERROR')
                container_status = <div className="s-fonticon-btn s-icon-status s-icon-status-error"></div>;
            else
                container_status = <div className="s-fonticon-btn s-icon-status s-icon-status-info"></div>;

            messages.push(
                <div
                    key={message._id || i}
                    style={{
                        display: 'flex',
                        padding: '15px',
                        width: '100%',
                        alignItems: 'flex-start'
                    }}
                >
                    {/* Status icon (don't let it shrink) */}
                    <div style={{ flexShrink: 0 }}>
                        {container_status}
                    </div>

                    {/* Message text (no truncation, wraps naturally) */}
                    <Label
                        id={'tooltip' + message._id}
                        style={{
                            fontSize: '.9rem',
                            flex: 1,
                            minWidth: 0,
                            marginLeft: '10px',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            overflowWrap: 'anywhere'
                        }}
                    >
                        {message.message}
                    </Label>

                    {/* Tooltip (optional, kept) */}
                    <Tooltip
                        placement="bottom"
                        isOpen={this.state[message._id]}
                        target={'tooltip' + message._id}
                        toggle={() => this.toggleToolTip(message.message, message._id)}
                    >
                        {message.message}
                    </Tooltip>

                    {/* Timestamp (don't let it shrink) */}
                    <Label
                        style={{
                            fontSize: '.7rem',
                            paddingLeft: '15px',
                            textAlign: 'right',
                            flexShrink: 0
                        }}
                    >
                        {moment(message.datetime).format('HH:mm:ss DD/MM/YYYY')}
                    </Label>
                </div>
            );
        });

    let infoModal = (
        <Modal
            isOpen={this.state.modal}
            toggle={this.toggle}
            className="modal-dialog"
            style={{ maxWidth: '80vw' }}
        >
            <ModalHeader toggle={this.toggle}>
                {modal_title}
            </ModalHeader>

            <ModalBody style={{ overflowX: 'hidden' }}>
                {messages}
            </ModalBody>

            <ModalFooter>
                {parentModal &&
                    <Button color="info" onClick={() => this.sendReport(processid)}>
                        Send Report
                    </Button>
                }
                <Button color="secondary" onClick={this.toggle}>Close</Button>
            </ModalFooter>
        </Modal>
    );

    if (this.state.collapse) {
        hide_button = '';
        tooltip_text = 'Hide Filter';
    } else {
        hide_button = '';
        tooltip_text = 'Show Filter';
    }

    return (
        <div className="App">
            <Header visible={!parsed.X3} />
            <div id="s-site-body" className="page-wrapper">
            <div className="s-page">
                <div className="s-page-header">
                    <Stack spacing={0.5} alignItems="flex-start" sx={{ mb: 3, textAlign: "left" }}>
                        <Typography variant="h5" sx={{ fontWeight: 600 }}>
                            {localisation['menu_header_event_viewer'] ? localisation['menu_header_event_viewer'].element_lang : 'Event Viewer'}
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            Review system events and processing activity
                        </Typography>
                    </Stack>
                </div>

                <div className="s-content-panel">
                <Collapse isOpen={this.state.collapse}>
                    <Form onSubmit={this.submitFilter} className="s-button-form">
                        <header className="s-h2-head-search">
                            <div title="Document" className="s-h2-title">Event Filter</div>
                        </header>

                        <Row form>
                            <Col md={4}>
                                <FormGroup className="s-field-core">
                                    <Label for="docRef" className="s-field-title s-anchored">Reference</Label>
                                    <Input
                                        type="text"
                                        name="DocumentRef"
                                        id="docRef"
                                        className="s-field-value-edit"
                                        value={this.state.reference}
                                        onChange={(e) => { this.setState({ reference: e.target.value }) }}
                                        placeholder="..."
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={4}>
                                <FormGroup className="s-field-core">
                                    <Label for="status" className="s-field-title s-anchored">Status</Label>
                                    <Input
                                        type="select"
                                        name="status"
                                        className="s-field-value-edit"
                                        value={this.state.status}
                                        onChange={(e) => { this.setState({ status: e.target.value }) }}
                                    >
                                        <option value="">Select ...</option>
                                        <option value={"COMPLETE"}>{"Complete"}</option>
                                        <option value={"INFO"}>{"Info"}</option>
                                        <option value={"ERROR"}>{"Error"}</option>
                                    </Input>
                                </FormGroup>
                            </Col>

                            <Col md={4}>
                                <FormGroup className="s-field-core">
                                    <Label for="actionType" className="s-field-title s-anchored">Action Type</Label>
                                    <Input
                                        type="select"
                                        name="actionType"
                                        className="s-field-value-edit"
                                        value={this.state.actionType}
                                        onChange={(e) => { this.setState({ actionType: e.target.value }) }}
                                    >
                                        <option value="">Select ...</option>
                                        <option value={"PROCESSING"}>{"Processing"}</option>
                                        <option value={"ARCHIVE"}>{"Archive"}</option>
                                        <option value={"EMAIL"}>{"Email"}</option>
                                        <option value={"PRINT"}>{"Print"}</option>
                                        <option value={"DROP"}>{"Drop"}</option>
                                        <option value={"SCAN"}>{"Scan"}</option>
                                        <option value={"POLLER"}>{"Poller"}</option>
                                        <option value={"FILEDROP"}>{"File Drop"}</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row form>
                            <Col md={6}>
                                <FormGroup className="s-field-core">
                                    <Label for="dateRageFrom" className="s-field-title s-anchored">Date From</Label>
                                    <Input
                                        type="date"
                                        name="DateRageFrom"
                                        id="dateRageFrom"
                                        className="s-field-value-edit"
                                        max="9999-12-31"
                                        value={this.state.fromDate}
                                        onChange={(e) => { this.setState({ fromDate: e.target.value }) }}
                                    />
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup className="s-field-core">
                                    <Label for="dateRageTo" className="s-field-title s-anchored">Date To</Label>
                                    <Input
                                        type="date"
                                        name="DateRageTo"
                                        id="dateRageTo"
                                        className="s-field-value-edit"
                                        max="9999-12-31"
                                        value={this.state.toDate}
                                        onChange={(e) => { this.setState({ toDate: e.target.value }) }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Box sx={{ display: 'flex', gap: 2, mt: 2, justifyContent: 'flex-end' }}>
                            <MuiButton variant="outlined" color="error" onClick={() => this.clearFilter()}>
                                Clear
                            </MuiButton>
                            <MuiButton variant="contained" type="submit">
                                Filter
                            </MuiButton>
                        </Box>
                    </Form>
                </Collapse>

                <div className="hidecontent">
                    <Button
                        outline
                        color="primary"
                        onClick={() => this.setState({ collapse: !this.state.collapse })}
                        id="hidebtn"
                        className="hidebtn search-button s-fonticon-btn"
                    >
                        {hide_button}
                    </Button>
                </div>

                <UncontrolledTooltip placement="bottom" target="hidebtn">
                    {tooltip_text}
                </UncontrolledTooltip>

                <div className="spacer" />

                <InfoTable
                    checked
                    loading={this.state.isLoading}
                    delete={this.remove}
                    refresh={this.refresh}
                    selectAll={this.selectAll}
                    onRowClicked={this.rowClicked}
                    checkChange={this.checkChange}
                    logs={this.state.logs}
                    checkedlogs={this.state.checkedLogs}
                    associated_events={this.state.associated_events}
                    expandLogs={this.expandLogs}
                    exportRows={this.exportButtonPressed}
                    pageNumberChange={(value) => this.setState({ page_number: value })}
                    columnConfig={{ expand: true, checkbox: true }}
                />

                <Box sx={{ display: 'flex', gap: 2, mt: 2, justifyContent: 'flex-end' }}>
                    <MuiButton onClick={this.remove} variant="outlined" color="error">
                        {localisation['remove_button'] ? localisation['remove_button'].element_lang : ''}
                    </MuiButton>

                    <Flag flag="v12" entity={{ id: 1 }} case="off">
                        <MuiButton onClick={this.retry} variant="contained" color="success">
                            {localisation['retry_button'] ? localisation['retry_button'].element_lang : ''}
                        </MuiButton>
                    </Flag>

                    <Flag flag="v12" entity={{ id: 1 }} case="on">
                        <MuiButton onClick={this.retry} variant="contained" color="success">
                            {localisation['retry_button'] ? localisation['retry_button'].element_lang : ''}
                        </MuiButton>
                    </Flag>
                </Box>
                </div>
            </div>
            </div>

            {this.state.exportFilesModalVisible &&
                <ExportDataRowsModal
                    files={this.state.logs}
                    type={'actions'}
                    visible={this.state.exportFilesModalVisible}
                    toggle={this.exportButtonPressed}
                />
            }

            {infoModal}
        </div>
    );
}

}

// Raw class exported for unit tests; the app uses the connected default export.
export { ConsoleView };
export default connect(state => state)(AuthHOC(withAlert()(ConsoleView), { name: 'event_viewer' }));